<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-modal
      width="900px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :canEdit="canEdit"
        :editData="editData"
        :isDetail="isDetail"
        :disabled="disabled"
        :submitBtn="!disabled"
        :data="tableData"
        :idField="idField"
        :ableBuildImport="ableBuildImport"
        :ableProImport="ableProImport"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{ codeToText(record.visitor_type, Enum.carVisitType.value) }}
        </template>
        <template v-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'applicant_gender'">
          {{ record.applicant_gender === 0 ? '男' : '女' }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'visitor_begin_time'">
          {{ record.visitor_begin_time }} 至 {{ record.visitor_end_time }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record, true)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'edit'"
              v-if="
                ableEdit && (record.state === 0 || record.state === 3 || record.state === 4)
              "
            >
              编辑
            </a-button>
            <a-button
              v-if="ableAdd"
              @click="showCopyModal(record)"
              :loading="loadingRecord === record[idField] + 'copy'"
            >
              复制
            </a-button>
            <!--<a-button
              @click="showExtension(record)"
              v-if="record.state === 2"
              @success="fetch()"
            >
              延期申请
            </a-button>-->
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-popconfirm
              title="确认提交？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="pushRow(record)"
              v-if="ableCommit && record.state === 0"
            >
              <a-button>提交</a-button>
            </a-popconfirm>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
              danger
            >撤销审批</a-button>
            <a-popconfirm
              v-if="ableDelete && (record.state !== 1 && record.state !== 2)"
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
    <extension_application ref="extensionRef"></extension_application>

    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revokeRow">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    getDetail,
    push,
    revoke,
    approvalProcess,
  } from '@/api/car_application/enterprise_application'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import approval_process from '@/components/approval_process'
  import extension_application from '@/components/extension_application'
  import dayjs from 'dayjs'

  //初始化
  const pageName = '园区企业预约申请'
  const idField = 'car_application_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:delete')
  )
  const ableCommit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:commit')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:revoke')
  )
  const ableProImport = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:proprietorImport')
  )
  const ableBuildImport = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carApply:buildImport')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_id',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    // {
    //   type: 'select',
    //   field: 'vehicle_type',
    //   storeOptions: 'carModel',
    //   label: '车型',
    //   width: '180px',
    //   'allow-clear': true,
    // },
    {
      type: 'input',
      field: 'applicant_name',
      label: '申请人姓名',
    },
    {
      type: 'input',
      field: 'applicant_phone',
      label: '申请人联系号码',
    },
    {
      type: 'input',
      field: 'applicant_idcard',
      label: '申请人身份证号码',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'input',
      field: 'interviewee_name',
      label: '被访人员',
    },
    {
      type: 'input',
      field: 'interviewee_phone',
      label: '被访人联系电话',
    },
    {
      type: 'select',
      field: 'visit_area',
      storeOptions: 'areaType',
      // defaultValue: 1,
      label: '申请园区',
      width: '130px',
      'allowClear': true,
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '审核状态',
      width: '130px',
    },
    {
      type: 'select',
      field: 'application_type',
      label: '申请类型',
      storeOptions: 'carVisitType',
      width: '110px',
      'allow-clear': true,
    },
    /*{
      type: 'select',
      field: 'is_delayed',
      storeOptions: 'delayedType',
      defaultValue: -1,
      label: '延期申请',
      width: '80px',
    },*/
    {
      type: 'dateRange',
      startField: 'visitor_begin_time',
      endField: 'visitor_end_time',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '有效时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setCarEnterApplice', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      key: 'application_number',
      dataIndex: 'application_number',
      align: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '车型',
      dataIndex: 'vehicle_type_name',
      key: 'vehicle_type_name',
      align: 'left',
      width: 180,
    },
    {
      title: '申请人',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      align: 'left',
    },
    {
      title: '申请人证件号码',
      key: 'applicant_idcard',
      dataIndex: 'applicant_idcard',
      align: 'left',
    },
    {
      title: '性别',
      key: 'applicant_gender',
      dataIndex: 'applicant_gender',
      align: 'left',
    },
    {
      title: '申请人联系号码',
      key: 'applicant_phone',
      dataIndex: 'applicant_phone',
      align: 'left',
    },
    {
      title: '申请园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
      width: 90,
    },
    {
      title: '申请类型',
      dataIndex: 'visitor_type',
      key: 'visitor_type',
      align: 'left',
      width: 80,
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180,
    },
    {
      title: '来访事由',
      dataIndex: 'visitor_content',
      key: 'visitor_content',
      align: 'left',
      width: 180,
    },
    {
      title: '入园时间',
      dataIndex: 'visitor_begin_time',
      key: 'visitor_begin_time',
      align: 'left',
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      align: 'left',
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      align: 'left',
    },
    {
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180,
    },
    {
      title: '审核状态',
      // dataIndex: 'state',
      // key: 'state',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '220px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchCarEnterApplice)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showDetailModal(record);
      }
    }
  }

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const canEdit = ref(true)
  const editData = ref(null)
  const disabled = ref(false)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    canEdit.value = true
    isDetail.value = false
    disabled.value = false
    open.value = true
  }
  const isDetail = ref(false)
  const showDetailModal = async (data, showDetail = false) => {
    loadingRecord.value = data[idField] + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      isDetail.value = showDetail
      disabled.value = true
      canEdit.value = false
      open.value = true
    }
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data[idField] + 'edit'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      isDetail.value = false
      disabled.value = false
      canEdit.value = true
      open.value = true
    }
  }
  const showCopyModal = async (data) => {
    loadingRecord.value = data[idField] + 'copy'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = false
      disabled.value = false
      canEdit.value = true
      isDetail.value = false
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }

  //5、提交
  async function pushRow(data) {
    const res = await push({ id: data[idField] })
    if (res.success) {
      message.success('提交成功！')
      fetch()
    } else {
      message.warn('提交失败' + res.message)
    }
  }
  //6、撤销审核
  async function revokeRow(data) {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revoke({ id, reason })
      if (res.success) {
        message.success('撤销审核成功！')
        fetch()
        revokeModalOpen.value = false
      } else {
        message.warn('撤销审核失败' + res.message)
      }
    } finally {
      loadingRecord.value = null
    }
  }

  //7、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }

  //8、延期申请
  const extensionRef = ref()
  function showExtension(record) {
    extensionRef.value.openExtension(record[idField])
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
</script>
